/**
 * @generated SignedSource<<dcffd89318438c0117a37de926410827>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuDimensionUnitRadioSelect_user$data = {
  readonly preferences: {
    readonly measurementUnit: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "SbSharedRefineMenuDimensionUnitRadioSelect_user";
};
export type SbSharedRefineMenuDimensionUnitRadioSelect_user$key = {
  readonly " $data"?: SbSharedRefineMenuDimensionUnitRadioSelect_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuDimensionUnitRadioSelect_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuDimensionUnitRadioSelect_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "measurementUnit",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b352608c998a41b0f2f5c60c1264464d";

export default node;
